import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "./hooks/useLenis";
import { ContentProvider, useContent } from "./content/ContentContext";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { SoundSection } from "./components/SoundSection";
import { Story } from "./components/Story";
import { Family } from "./components/Family";
import { Episodes } from "./components/Episodes";
import { LatestEpisode } from "./components/LatestEpisode";
import { Lessons } from "./components/Lessons";
import { Quotes } from "./components/Quotes";
import { Watch } from "./components/Watch";
import { Newsletter } from "./components/Newsletter";
import { Creator } from "./components/Creator";
import { Footer } from "./components/Footer";
import Admin from "./components/Admin";

const SECTION_COMPONENTS = {
  sound: SoundSection,
  story: Story,
  family: Family,
  episodes: Episodes,
  latest: LatestEpisode,
  lessons: Lessons,
  quotes: Quotes,
  watch: Watch,
  newsletter: Newsletter,
  creator: Creator,
};

const Site = () => {
  useLenis();
  const { SECTIONS } = useContent();

  return (
    <div className="App grain" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        {SECTIONS.filter((s) => s.visible !== false).map((s) => {
          const C = SECTION_COMPONENTS[s.id];
          return C ? <C key={s.id} /> : null;
        })}
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
};

function App() {
  if (window.location.pathname.startsWith("/admin") || window.location.hash === "#admin") {
    return <Admin />;
  }
  return (
    <ContentProvider>
      <Site />
    </ContentProvider>
  );
}

export default App;
